/* eslint-disable import/no-internal-modules */
import { useEffect } from 'react';
export function FontProvider(props) {
    useEffect(() => {
        switch (props.theme) {
            case undefined:
                return;
            case 'magicline':
            case 'planet-fitness':
                void import('@fontsource/roboto/300.css');
                void import('@fontsource/roboto/400.css');
                void import('@fontsource/roboto/500.css');
                void import('@fontsource/roboto/700.css');
                return;
            case 'perfectgym': {
                void import('./assets/averta.css');
                return;
            }
        }
    }, [props.theme]);
    return null;
}
